
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...match]",
      function () {
        return require("private-next-pages/[...match].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...match]"])
      });
    }
  